// import LazyLoad from "react-lazyload";
import { Props } from "@/models";
import { motion, Variants } from "framer-motion";
import { memo } from "react";
import "./style.css";

// LazyLoadImage Component
export const LazyLoadImage = ({
  src,
  alt,
  className,
  height,
  offset,
  animate,
  once,
}: Props.LazyLoadImage) => {
  return (
    <div>
      <motion.img className={className} src={src} alt={alt} animate={animate} />
    </div>
  );
};

// Bounce Variants
const bounceVariants: Variants | undefined = {
  animate: {
    y: [0, -20, 0],
    transition: {
      duration: 2,
      repeat: Infinity,
      repeatType: "loop",
    },
  },
};

// Bounce Component
const Bounce = ({ src, alt, className, height }: Props.LazyLoadImage) => {
  return (
    <motion.img
      src={src}
      alt={alt}
      className={className}
      height={height}
      animate="animate"
      variants={bounceVariants}
    />
  );
};

// BounceAround Component (Static class-based CSS animation)
const BounceAround = ({ src, alt, className, height }: Props.LazyLoadImage) => {
  return (
    <img
      src={src}
      alt={alt}
      className={`${className} bouncer`}
      height={height}
    />
  );
};

// Shake Variants
const shakeVariants: Variants | undefined = {
  animate: {
    rotate: [0, 10, -10, 0],
    transition: {
      duration: 4.5,
      repeat: Infinity,
      ease: "easeInOut",
    },
  },
};

// Shake Component
const Shake = ({ src, alt, className, height }: Props.LazyLoadImage) => {
  return (
    <motion.img
      src={src}
      alt={alt}
      className={className}
      height={height}
      variants={shakeVariants}
      animate="animate"
    />
  );
};

// BottomToTop Variants
const bottomToTopVariants = (top: number): Variants | undefined => ({
  animate: {
    y: top,
    transition: {
      duration: 4.5,
      ease: "easeInOut",
    },
  },
});

// BottomToTop Component
const BottomToTop = ({
  src,
  alt,
  className,
  height,
  top,
}: Props.LazyLoadImage) => {
  return (
    <motion.img
      src={src}
      alt={alt}
      height={height}
      className={className}
      variants={bottomToTopVariants(top ?? 0)}
      animate="animate"
    />
  );
};

// Memoized Components
LazyLoadImage.Bounce = memo(Bounce);
LazyLoadImage.BounceAround = memo(BounceAround);
LazyLoadImage.Shake = memo(Shake);
LazyLoadImage.BottomToTop = memo(BottomToTop);
